import { render, staticRenderFns } from "./loseWeight.vue?vue&type=template&id=38d8cfc0&scoped=true"
import script from "./loseWeight.vue?vue&type=script&lang=js"
export * from "./loseWeight.vue?vue&type=script&lang=js"
import style0 from "./loseWeight.vue?vue&type=style&index=0&id=38d8cfc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d8cfc0",
  null
  
)

export default component.exports